<template>
    <div
        class="pointer-events-none absolute bottom-0 z-[var(--z-planets)] h-full w-full"
    >
        <div class="sticky top-0 w-full">
            <div class="w-full overflow-hidden">
                <div class="slt-gsap-planets-wrapper relative">
                    <TresCanvas
                        renderMode="on-demand"
                        windowSize
                        :dpr="[1, 2]"
                        style="position: relative; pointer-events: none"
                        :toneMapping="NoToneMapping"
                        :preset="'flat'"
                        :precision="'mediump'"
                        :premultipliedAlpha="false"
                        :preserveDrawingBuffer="false"
                        :stencil="false"
                        :useLegacyLights="false"
                        :powerPreference="'high-performance'"
                    >
                        <MoleculesLandscapeExperience />
                    </TresCanvas>
                    <!-- Gradient overlay -->
                    <div
                        class="slt-gsap-planets-overlay absolute bottom-0 left-0 h-[50%] w-full bg-gradient-to-t from-black to-transparent"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { NoToneMapping } from "three";
</script>
